module.exports = __webpack_public_path__ + "img/blog1.24dd080e.jpg";